// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import Title from '../Title/'

import './index.css'

export default class MenuItem extends Component {

  render () {
    const {buttonText, date, href, title} = this.props

    return (
      <div className='col menu-item-container'>
        <Title>
          {title}
        </Title>
        {
          date &&
            <div className='col-12 date'>
              {date}
            </div>
        }
        <div className='children col-12'>
          {this.props.children}
        </div>
        {
          buttonText &&
            <div className='button pull-right'>
              <a target='_blank' rel='noopener noreferrer' href={href || '/#'} className='btn'>{buttonText}</a>
            </div>
        }
      </div>
    )
  }
}
